import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import isEqual from 'lodash.isequal';
import {initial} from "../../../common/domain/RemoteData.model";
import {remoteDataWithSetter} from "../../../common/utils/remoteDataWithSetter";
import {fetchFilterData} from "./FilterService";

const FilterContext = createContext();
FilterContext.displayName = 'FilterContext';

export const useFilterContext = () => useContext(FilterContext);

export const FilterContextProvider = ({initialFilters = {}, children}) => {
    const [filterOptionsRemoteData, setFilterOptionsRemoteData] = useState(initial([]));
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        remoteDataWithSetter(setFilterOptionsRemoteData, fetchFilterData).then();
    }, []);


    const updateFilters = useCallback((newFilters) => {
        if (typeof newFilters === 'object' && newFilters !== null) {
            // Si el contenido no cambia, no se crea objeto nuevo: cada identidad nueva
            // dispara refetch y re-sincronizacion con la URL, y las actualizaciones
            // redundantes son la gasolina de los bucles URL<->contexto.
            setFilters(previous => (isEqual(previous, newFilters) ? previous : {...newFilters}));
        }
    }, []);

    const clearFilters = useCallback(() => setFilters({}), []);

    const context = useMemo(() => ({
        filters,
        updateFilters,
        clearFilters,
        filterOptionsRemoteData,
        setFilterOptionsRemoteData,
    }), [filters, updateFilters, clearFilters, filterOptionsRemoteData]);

    return (
        <FilterContext.Provider value={context}>
            {children}
        </FilterContext.Provider>
    );
};
